import React, { useState, useEffect } from "react";
import CrudStudentsList from '../../features/crudStudent/CrudStudentsList';
import { getStudent } from '../../services/scpApi';
import { useNavigate } from 'react-router-dom';

const AllStudents = () => {

    const [view, setView] = useState("");
    const [selectedSingleItemId, setSelectedSingleItemId] = useState(null);
    const [selectedStudent, setStudent] = useState(null);
    const [loading, setLoading] = useState(null);
    const navigate = useNavigate();

    const handleAddNew = () => {
        setSelectedSingleItemId(null);
        setStudent(null);
        navigate('/portal/manage-students?view=single');
    };

    const refreshSelectedStudent = () => {
        if (!selectedSingleItemId) {
            return;
        }

        (async () => {
            try {
                const student = await getStudent(selectedSingleItemId); 
                setStudent(student);
            } catch (error) {
                console.error('Error fetching student:', error);
            }
        })();
    }

    useEffect(() => {
        (async () => {
            if (!selectedSingleItemId) {
                return;
            }
            try {
                // fetch student data
                const student = await getStudent(selectedSingleItemId);
                setStudent(student);
            } catch (error) {
                console.error('Error fetching student:', error);
                setLoading('error');
            }
        })();
    }, [selectedSingleItemId]);

    return (
        <div className="all-students">
            <button onClick={handleAddNew} className="add-new">Add New Student</button>
            <CrudStudentsList setSelectedSingleItemId={setSelectedSingleItemId} setView={() => setView('single')} />
        </div>

    );
};

export default AllStudents;